module.exports = __webpack_public_path__ + "img/slwh.761fac72.jpg";